module.exports = __webpack_public_path__ + "static/fondo-servicios-3ad4a59444bccb5b8b0ad3b1433dae03.jpg";